import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { FormActions, Select, Radio } from '../../common/components/formControls';
import CentersDropdownList from '../centers/DropdownList';
import { withTranslation } from 'react-i18next';
import validators from '../../common/services/validators';

const UserMappingForm = ({ error, handleSubmit, pristine, submitting, isReadonly, saveSucceeded, franchisees,
	restrictedTo, restrictedToChange, t }) => {
	const restrictedToOptions = [
		{ value: '0', label: t('UserMapping_NoRestriction') },
		{ value: '1', label: t('UserMapping_ToFranchisee') },
		{ value: '2', label: t('UserMapping_ToCenter') }
	];
	
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{/* pristine hides the confirmation as soon as a field is edited again; the radio also clears
			    saveSucceeded through restrictedToChange, because switching it reinitialises the form */}
			{saveSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Field name='restrictedTo' component={Radio} entries={restrictedToOptions} disabled={isReadonly} inline horizontal label={t('UserMapping_RestrictedTo')} onChange={restrictedToChange} />
			{(!restrictedTo || restrictedTo == '0') && <Alert bsStyle='warning'>{t('SystemUser_NoRestrictionWarning')}</Alert>}
			{restrictedTo == '1' && <Select name='franchiseeId' disabled={isReadonly} horizontal label={t('UserMapping_Franchisee')} data={franchisees} required validate={validators.required} />}
			{restrictedTo == '2' && <CentersDropdownList render='field' name='centerId' disabled={isReadonly} horizontal label={t('UserMapping_Center')} required validate={validators.required} />}
			<FormActions horizontal>
				<Button type='submit' disabled={isReadonly || submitting} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'userMappingForm', enableReinitialize: true })(withTranslation()(UserMappingForm));
